import './style.scss';
import jQuery from 'jquery';

jQuery(function($) {
    $('.lpcb-accordion__head').on('click', function() {

        $(this).next().slideToggle(300, 'linear');

        $(this).toggleClass('is-open');
    })
})